export default __webpack_public_path__ + "static/media/add-user-disabled.94a21a91.svg";